import { RESTApiAdapter } from 'DataAccessLayer/Adapters/RESTApiAdapter';
import { autoinject } from 'aurelia-dependency-injection';

@autoinject
export class BaseService {
    protected restApiAdapter : RESTApiAdapter = null;

    constructor(restApiAdapter: RESTApiAdapter) {
        this.restApiAdapter = restApiAdapter;
    }
}